import "./TodoError.css"

function TodoError() {
  return <p>Error al cargar los datos</p>;
}

export { TodoError };